import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=9bb254d0&scoped=true&"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&id=9bb254d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb254d0",
  null
  
)

export default component.exports